import { SvgIcon } from "@mui/material";
import React from "react";

const WhiteBoard = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 35.211 21.132">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35.211"
        height="21.132"
        viewBox="0 0 35.211 21.132"
      >
        <g id="white-board" transform="translate(-10 -30.093)">
          <path
            id="Path_6055"
            data-name="Path 6055"
            d="M0,0H32.862V18.455H0Z"
            transform="translate(11.174 30.093)"
            fill="#fff"
          />
          <path
            id="Path_6049"
            data-name="Path 6049"
            d="M142.29,60.671a.44.44,0,0,0-.44-.44h-5.378a1.631,1.631,0,0,1-1.287-.624l-1.726-2.186a.44.44,0,1,0-.691.545l1.726,2.186a2.506,2.506,0,0,0,1.978.959h5.378A.44.44,0,0,0,142.29,60.671Zm-8.914-9.454a.439.439,0,0,0,.293-.112l1.574-1.407a1.638,1.638,0,0,1,1.093-.418h6.1a.44.44,0,0,0,0-.88h-6.1a2.517,2.517,0,0,0-1.68.641l-1.574,1.408a.44.44,0,0,0,.293.768Zm9.5-.66a.44.44,0,0,0-.44-.44h-3.369a.44.44,0,1,0,0,.88h3.369A.44.44,0,0,0,142.878,50.558ZM141.868,62.1H138.5a.44.44,0,0,0,0,.88h3.369a.44.44,0,1,0,0-.88Zm3.626-7.84h4.27a.44.44,0,0,0,0-.88h-4.27a.44.44,0,0,0,0,.88Zm-3.5-.44a.44.44,0,0,0,.44.44H143.5a.44.44,0,0,0,0-.88h-1.067A.44.44,0,0,0,142,53.816Zm7.766,1.612h-7.326a.44.44,0,0,0,0,.88h7.326a.44.44,0,1,0,0-.88Zm0,2.052h-7.326a.44.44,0,0,0,0,.88h7.326a.44.44,0,1,0,0-.88Z"
            transform="translate(-109.175 -16.293)"
            fill="#697e96"
          />
          <path
            id="Path_6050"
            data-name="Path 6050"
            d="M10,197.811H45.211v.763a1.915,1.915,0,0,1-1.915,1.915H11.915A1.915,1.915,0,0,1,10,198.574Z"
            transform="translate(0 -149.263)"
            fill="#9fb8ad"
          />
          <path
            id="Path_6053"
            data-name="Path 6053"
            d="M126.482,56.784a3.929,3.929,0,0,0-3.549-2.242v3.93Z"
            transform="translate(-100.507 -21.759)"
            fill="#f26674"
          />
          <path
            id="Path_6054"
            data-name="Path 6054"
            d="M64.946,74.843a4.835,4.835,0,1,0,9.2-2.076l-4.368,2.076V70.008a4.835,4.835,0,0,0-4.835,4.835Z"
            transform="translate(-48.9 -35.523)"
            fill="#ff4b5c"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default WhiteBoard;
